import styled from "styled-components";

export const Title = () => <StyledTitle>Рекламувати об’єкт</StyledTitle>;

const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: var(--font-weight-200);
  color: var(--color-2);
  line-height: 22.79px;
  letter-spacing: 0.02em;
  text-align: left;
  margin-bottom: 14px;
`;
